/* Candy4U — BUNDLES page behaviour (sections/candy-bundles.liquid, id bnd8x4).
   One delegated listener on the section, so the copy of a card the finder shows behaves exactly like the original. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bnd]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- hero: plays once on screen (held on its last frame unless looped), jump button scrolls to the eight ---- */
  var hero = root.querySelector('[data-bnd-hero]');
  if (hero) {
    hero.muted = true;
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { var p = hero.play(); if (p && p.catch) p.catch(function () {}); }
          else hero.pause();
        });
      }, { threshold: 0.3 }).observe(hero);
    }
  }
  var jump = root.querySelector('[data-bnd-jump]');
  if (jump) jump.addEventListener('click', function (ev) {
    var t = document.getElementById('bnd-eight');
    if (!t) return;
    ev.preventDefault();
    var off = (function(v){return (parseFloat(v)||0) * (/vw\s*$/.test(v) ? window.innerWidth / 100 : 1);})(getComputedStyle(document.documentElement).getPropertyValue('--c4u-hdr-off'));
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off - 10, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---- the pour: the product page's fill animation (assets/candy-pack.js / .css), replayed on demand ---- */
  function pour(card) {
    if (reduce || !card) return;
    var pk = card.querySelector('.c4u-pk');
    if (!pk) return;
    pk.classList.remove('c4u-pk--go');
    void pk.offsetWidth;
    pk.classList.add('c4u-pk--go');
  }
  if (window.c4uPackWatch) window.c4uPackWatch(root);
  else document.addEventListener('DOMContentLoaded', function () { if (window.c4uPackWatch) window.c4uPackWatch(root); });

  /* ---- optional pour videos: only while on screen AND (desktop) hovered or (phone) open, never more than four at once ---- */
  var playing = [];
  function startVid(card) {
    var v = card && card.querySelector('[data-bnd-vid]');
    if (!v || reduce) return;
    if (!v.getAttribute('poster') && v.dataset.poster) v.setAttribute('poster', v.dataset.poster);
    if (!v.getAttribute('src')) {
      var s = v.querySelector('source[data-src]');
      if (s) { s.setAttribute('src', s.getAttribute('data-src')); s.removeAttribute('data-src'); v.load(); }
    }
    if (playing.indexOf(v) === -1) {
      if (playing.length >= 4) { var old = playing.shift(); old.pause(); old.closest('[data-bnd-card]').classList.remove('is-vid'); }
      playing.push(v);
    }
    v.muted = true;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    card.classList.add('is-vid');
  }
  function stopVid(card) {
    var v = card && card.querySelector('[data-bnd-vid]');
    if (!v) return;
    v.pause();
    var i = playing.indexOf(v); if (i > -1) playing.splice(i, 1);
    card.classList.remove('is-vid');
  }
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) stopVid(e.target); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bnd-card]'), function (c) { if (c.querySelector('[data-bnd-vid]')) vio.observe(c); });
  }

  if (fine) {
    root.addEventListener('mouseover', function (ev) {
      var card = ev.target.closest('[data-bnd-hover]');
      if (!card || card.contains(ev.relatedTarget)) return;
      pour(card); startVid(card);
    });
    root.addEventListener('mouseout', function (ev) {
      var card = ev.target.closest('[data-bnd-hover]');
      if (!card || card.contains(ev.relatedTarget)) return;
      stopVid(card);
    });
  }

  /* ---- open in place: one card open at a time; the drawer height is a CSS grid-rows transition under 0.5s ---- */
  function setOpen(card, on) {
    card.classList.toggle('is-open', on);
    var b = card.querySelector('[data-bnd-toggle]');
    if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  root.addEventListener('click', function (ev) {
    /* the photo-count pill opens the bundle's photos. On a compare-view row there is no card around it: the button names its
       bundle (data-bnd-for). Focus goes back to the pill. The picture (and a compare row's name) is a plain link to the
       bundle's own product page (client 2026-10-07: "not a proper product page like the others"), so it is left to go
       and never turns the card. The +, and the rest of the front, turn the card. */
    var pics = ev.target.closest('[data-bnd-pics]');
    if (pics) {
      var forH = pics.getAttribute('data-bnd-for');
      openPhotos(forH ? root.querySelector('[data-bnd-panel="cards"] [data-bnd-card="' + forH + '"]') : pics.closest('[data-bnd-card]'), pics);
      return;
    }
    if (ev.target.closest('a[href]')) return;
    var t = ev.target.closest('[data-bnd-toggle]') || ev.target.closest('[data-bnd-face]');
    if (t) {
      var card = t.closest('[data-bnd-card]');
      var open = !card.classList.contains('is-open');
      var scope = card.parentElement;
      /* each card stays as it is until its own x is pressed (2026-09-27: opening one must not turn the others back) */
      setOpen(card, open);
      if (open) { pour(card); if (!fine) startVid(card); } else if (!fine) stopVid(card);
      return;
    }
    var add = ev.target.closest('[data-bnd-add]');
    if (add) { addToBasket(add); return; }
    var view = ev.target.closest('[data-bnd-view]');
    if (view) { setView(view.getAttribute('data-bnd-view')); return; }
  });

  /* ---- photos (client 2026-10-07: "make the hero image clickable so we can view the rest of the images for each bundle";
     since 4:20pm that day the picture opens the product page and the photo-count pill opens this):
     every photo of the bundle, from the card's own list (data-bnd-photos). Arrows, swipe, thumbnails, keys; Esc, x or the
     dark around it closes. One viewer for the page, moved under <body> so a turned card can never trap its fixed position. ---- */
  var lb = document.querySelector('[data-bnd-lb]');
  var lbImg, lbTitle, lbCount, lbThumbs, lbStage, lbPics = [], lbAt = 0, lbFrom = null, lbX = null, lbHideT = 0;
  if (lb) {
    document.body.appendChild(lb);
    lbImg = lb.querySelector('[data-bnd-lb-img]'); lbTitle = lb.querySelector('[data-bnd-lb-title]');
    lbCount = lb.querySelector('[data-bnd-lb-count]'); lbThumbs = lb.querySelector('[data-bnd-lb-thumbs]');
    lbStage = lb.querySelector('[data-bnd-lb-stage]');
    lbImg.addEventListener('load', function () { lbImg.classList.add('is-in'); });
    lb.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-bnd-lb-close]')) { closePhotos(); return; }
      if (ev.target.closest('[data-bnd-lb-prev]')) { showPhoto(lbAt - 1); return; }
      if (ev.target.closest('[data-bnd-lb-next]')) { showPhoto(lbAt + 1); return; }
      var th = ev.target.closest('[data-bnd-lb-to]');
      if (th) showPhoto(Number(th.getAttribute('data-bnd-lb-to')));
    });
    document.addEventListener('keydown', function (ev) {
      if (lb.hidden) return;
      if (ev.key === 'Escape') { ev.preventDefault(); ev.stopPropagation(); closePhotos(); }
      else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowRight') { ev.preventDefault(); ev.stopPropagation(); showPhoto(lbAt + (ev.key === 'ArrowRight' ? 1 : -1)); }
      else if (ev.key === 'Tab') {
        var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
        else if (!lb.contains(document.activeElement)) { ev.preventDefault(); f[0].focus(); }
      }
    }, true);
    /* swipe: a sideways drag of 40px on the photo turns to the next or previous one */
    lbStage.addEventListener('pointerdown', function (ev) { if (ev.isPrimary) lbX = ev.clientX; });
    lbStage.addEventListener('pointerup', function (ev) {
      if (lbX === null) return;
      var dx = ev.clientX - lbX; lbX = null;
      if (Math.abs(dx) > 40 && lbPics.length > 1) showPhoto(lbAt + (dx < 0 ? 1 : -1));
    });
    lbStage.addEventListener('pointercancel', function () { lbX = null; });
  }
  function openPhotos(card, from) {
    if (!lb || !card) return;
    var data = card.querySelector('[data-bnd-photos]');
    try { lbPics = data ? JSON.parse(data.textContent) : []; } catch (e) { lbPics = []; }
    if (!lbPics.length) return;
    var nm = card.querySelector('.custom-bnd8x4__name');
    lbTitle.textContent = nm ? nm.textContent.trim() : '';
    lbThumbs.innerHTML = '';
    lb.classList.toggle('is-single', lbPics.length < 2);
    lbPics.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'custom-bnd8x4__lb-th';
      b.setAttribute('data-bnd-lb-to', String(i));
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + lbPics.length);
      var im = document.createElement('img');
      im.src = p.t; im.alt = ''; im.decoding = 'async';
      b.appendChild(im); lbThumbs.appendChild(b);
    });
    lbFrom = from || card.querySelector('[data-bnd-pics]');
    clearTimeout(lbHideT);
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--bnd-sbw', ((sbw > 0 ? sbw : 0) / window.innerWidth * 100) + 'vw');
    document.documentElement.classList.add('custom-bnd8x4-lock');
    lb.hidden = false;
    showPhoto(0);
    requestAnimationFrame(function () { requestAnimationFrame(function () { lb.classList.add('is-on'); }); });
    var x = lb.querySelector('.custom-bnd8x4__lb-x');
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
  }
  function showPhoto(i) {
    var n = lbPics.length;
    if (!n) return;
    lbAt = ((i % n) + n) % n;
    var p = lbPics[lbAt];
    lbImg.classList.remove('is-in');
    lbImg.sizes = '(max-width: 768px) 100vw, 60vw';
    lbImg.srcset = p.m + ' 900w, ' + p.s + ' 1600w';
    lbImg.src = p.s;
    lbImg.alt = p.a || '';
    if (lbImg.complete && lbImg.naturalWidth) lbImg.classList.add('is-in');
    lbCount.textContent = (lbAt + 1) + ' / ' + n;
    Array.prototype.forEach.call(lbThumbs.children, function (b, k) {
      if (k !== lbAt) { b.removeAttribute('aria-current'); return; }
      b.setAttribute('aria-current', 'true');
      /* keep the current thumbnail in view inside its own strip (never scrolls the page) */
      var L = b.offsetLeft, W = b.offsetWidth, s = lbThumbs.scrollLeft, V = lbThumbs.clientWidth;
      if (L < s) lbThumbs.scrollLeft = L - 12;
      else if (L + W > s + V) lbThumbs.scrollLeft = L + W - V + 12;
    });
    /* the next and previous photo load while this one is looked at */
    [lbAt + 1, lbAt - 1].forEach(function (k) {
      var q = lbPics[((k % n) + n) % n];
      if (!q || q === p) return;
      var pre = new Image(); pre.sizes = lbImg.sizes; pre.srcset = q.m + ' 900w, ' + q.s + ' 1600w'; pre.src = q.s;
    });
  }
  function closePhotos() {
    if (!lb || lb.hidden) return;
    lb.classList.remove('is-on');
    document.documentElement.classList.remove('custom-bnd8x4-lock');
    lbHideT = setTimeout(function () { lb.hidden = true; lbImg.removeAttribute('srcset'); lbImg.removeAttribute('src'); lbImg.classList.remove('is-in'); }, reduce ? 0 : 260);
    if (lbFrom) { try { lbFrom.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---- add to basket: the same call as the rest of the site; the cart drawer opens on candy:cart:added ---- */
  function addToBasket(btn) {
    if (btn.disabled || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var label = btn.getAttribute('data-label') || btn.textContent;
    var message = btn.parentElement.querySelector('[data-bnd-message]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'custom-bnd8x4__message';
      message.setAttribute('data-bnd-message', '');
      message.setAttribute('role', 'status');
      btn.insertAdjacentElement('afterend', message);
    }
    message.textContent = '';
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    var cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-bnd-add')), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Unable to add this bundle. Please try again.');
        return data;
      });
    })
      .then(function () { document.dispatchEvent(new CustomEvent('candy:cart:added')); btn.textContent = 'Added'; message.textContent = 'Added to your basket.'; })
      .catch(function (error) { btn.textContent = 'Try again'; message.textContent = error.message === 'Failed to fetch' ? 'Please check your connection and try again.' : error.message; })
      .then(function () {
        btn.classList.remove('is-loading'); btn.setAttribute('aria-busy', 'false');
        setTimeout(function () { btn.textContent = label; delete btn.dataset.busy; }, 1200);
      });
  }

  /* ---- cards / compare toggle ---- */
  function setView(v) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-bnd-view]'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-bnd-view') === v ? 'true' : 'false'); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bnd-panel]'), function (p) { p.hidden = p.getAttribute('data-bnd-panel') !== v; });
    if (v === 'cards' && window.c4uPackWatch) window.c4uPackWatch(root);
  }

  /* ---- the finder: questions and the answer -> bundle map come from the admin (metaobjects) as JSON ---- */
  var fbox = root.querySelector('[data-bnd-finder]');
  var fdata = root.querySelector('[data-bnd-fdata]');
  if (fbox && fdata) {
    var data; try { data = JSON.parse(fdata.textContent); } catch (e) { data = null; }
    if (data && data.questions && data.questions.length) {
      var qs = data.questions.slice().sort(function (a, b) { return (a.s || 0) - (b.s || 0); });
      var ms = (data.matches || []).slice().sort(function (a, b) { return (a.p || 999) - (b.p || 999); });
      var elStep = fbox.querySelector('[data-bnd-fstep]'), elQ = fbox.querySelector('[data-bnd-fq]'),
          elO = fbox.querySelector('[data-bnd-fopts]'), elRes = fbox.querySelector('[data-bnd-fres]'),
          elWhy = fbox.querySelector('[data-bnd-freason]'), elCard = fbox.querySelector('[data-bnd-fcard]');
      var answers = [];
      var norm = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
      var ask = function () {
        var i = answers.length;
        if (i >= qs.length) return result();
        elRes.hidden = true; elQ.hidden = false; elO.hidden = false; elStep.hidden = false;
        elStep.textContent = 'Question ' + (i + 1) + ' of ' + qs.length;
        elQ.textContent = qs[i].q || '';
        elO.innerHTML = '';
        (qs[i].o || []).slice(0, 4).forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'custom-bnd8x4__fopt'; b.textContent = o;
          b.addEventListener('click', function () { answers.push(o); ask(); });
          elO.appendChild(b);
        });
      };
      var result = function () {
        var hit = null;
        for (var k = 0; k < ms.length && !hit; k++) {
          var m = ms[k], ok = true;
          for (var j = 0; j < answers.length; j++) {
            var want = (m.a && m.a[j] != null) ? m.a[j] : '*';
            if (norm(want) !== '*' && norm(want) !== norm(answers[j])) { ok = false; break; }
          }
          if (ok && m.h) hit = m;
        }
        elStep.hidden = true; elQ.hidden = true; elO.hidden = true; elRes.hidden = false;
        elCard.innerHTML = '';
        if (!hit) { elWhy.textContent = 'We could not match that one yet. Have a look at all eight above.'; return; }
        elWhy.textContent = hit.r || '';
        var src = root.querySelector('[data-bnd-panel="cards"] [data-bnd-card="' + hit.h + '"]');
        if (src) {
          var copy = src.cloneNode(true);
          copy.classList.remove('is-open', 'is-vid');
          copy.removeAttribute('data-bnd-hover');
          Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (n) { n.id = 'finder-' + n.id; });
          Array.prototype.forEach.call(copy.querySelectorAll('[aria-controls]'), function (n) { n.setAttribute('aria-controls', 'finder-' + n.getAttribute('aria-controls')); });
          Array.prototype.forEach.call(copy.querySelectorAll('[data-bnd-message]'), function (n) { n.remove(); });
          Array.prototype.forEach.call(copy.querySelectorAll('.c4u-pk'), function (n) { n.classList.remove('c4u-pk--go'); });
          elCard.appendChild(copy);
          var tb = copy.querySelector('[data-bnd-toggle]'); if (tb) tb.setAttribute('aria-expanded', 'false');
          /* the result screen carries its own Add to basket (brief: "collapsed card ... Add to basket and a small Try again link") */
          var fadd = fbox.querySelector('[data-bnd-fadd]');
          var sb = src.querySelector('[data-bnd-add]');
          if (fadd) { fadd.innerHTML = ''; if (sb) { var nb = sb.cloneNode(true); delete nb.dataset.busy; nb.classList.remove('is-loading'); nb.removeAttribute('aria-busy'); nb.textContent = nb.getAttribute('data-label'); fadd.appendChild(nb); } }
          setTimeout(function () { pour(copy); }, 60);
        }
      };
      fbox.querySelector('[data-bnd-again]').addEventListener('click', function () { answers = []; ask(); });
      ask();
    }
  }
})();
